'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = {
    SORT_BY_NAME: 'name'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mattermost-redux/constants/emoji.js
// module id = 641
// module chunks = 27